import { PracticeStateMachine } from '@/app/practice-player/domain'
import { ExamStateMachine } from '@/app/exam-player/domain'
import { QuizPlayerStateMachinePhase } from '../data'
import { CancelToken } from '@/app/shared/utils'
import { reportNonFatalError } from '@/app/error-handling'

export type QuizMode = 'exam' | 'practice'

export type QuizStartOptions = {
  mode: 'exam'
} | {
  mode: 'practice'
  questionCount: number
}

export type ChildStateMachine = PracticeStateMachine | ExamStateMachine

export interface QuizPlayerStateMachineCommonEvents {
  onCanceled: () => void
  onError: (err: unknown) => void
}

export abstract class QuizPlayerStateMachineAbstractState<TEvents extends QuizPlayerStateMachineCommonEvents>
{
  abstract name: QuizPlayerStateMachinePhase
  stateEvents: TEvents | null
  protected cancelToken: CancelToken = { cancel: false }
  
  abstract cancel(): void

  protected beginCancel() {
    this.cancelToken.cancel = true
  }

  protected endCancel() {
    this.triggerEvent(events => events.onCanceled())
  }

  triggerEvent(action: (events: TEvents) => void) {
    if (this.stateEvents) {
      action(this.stateEvents)
    } else {
      reportNonFatalError(
        `triggerEvent called after state exit at '${this.name}' state`, action)
    }
  }
}

